<template>
  <div>
    <SfHeading :level="4" :title="$t('Quick Cart')" class="sf-heading--left" />
    <SfInput name="part"
      v-model="part"
      :placeholder="$t('Part Number')" :aria-label="$t('Part Number')" />
    <SfQuantitySelector
      class="m-b-10" v-model="qty" aria-label="Quantity" />
    <SfButton
      class="fz-input-button__button sf-button--outline sf-button--full-width"
      :disabled="!part"
      @click.prevent="search(part)"
    >
      {{ $t("Add to cart") }}
    </SfButton>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
  SfButton, SfInput, SfHeading, SfQuantitySelector,
} from '@storefront-ui/vue';

export default {
  name: 'QuickCart',
  components: {
    SfButton,
    SfInput,
    SfHeading,
    SfQuantitySelector,
  },
  data() {
    return {
      part: '',
      qty: 1,
    };
  },
  computed: {
    disabled() {
      return !this.qty;
    },
    ...mapGetters({
      vehicleData: 'level4/vehicleData',
    }),
  },
  methods: {
    search(part) {
      this.searchByParts({
        Sku: part,
        EquipmentList: [],
        VehicleKeyList: [],
      }).then((data) => this.addItemToCart({
        ProductId: data.SimpleProduct.Id,
        Quantity: this.qty || 1,
      })).then(() => {
        this.part = '';
        this.qty = 1;
        this.fetchCart();
      });
    },
    ...mapActions({
      searchByParts: 'level4/searchByParts',
      addItemToCart: 'checkout/addItemToCart',
      fetchCart: 'checkout/fetchCart',
    }),
  },
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/helpers";
@import "src/scss/_breakpoint";

.sf-heading {
  @include flexbox-desktop {
    margin-bottom: var(--spacer-sm);
  }
}

.sf-button--outline {
  --button-border-color: var(--_c-gray-secondary);
  --button-color: var(--_c-gray-secondary);
}
</style>
